(function () {
  history.scrollRestoration = 'manual';

  const STORAGE_KEY = 'sus_scroll_restore';

  function getCollectionKey() {
    return window.location.pathname;
  }

  function saveState() {
    const pageInput = document.querySelector('[data-current-page]');
    const currentPage = pageInput ? parseInt(pageInput.value, 10) : 1;
    sessionStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({
        key: getCollectionKey(),
        scrollY: Math.round(window.scrollY),
        page: currentPage
      })
    );
  }

  function attachCardListeners() {
    const cards = document.querySelectorAll('#product-grid .collection-product-card a');
    cards.forEach(function (link) {
      if (!link.dataset.susScrollListened) {
        link.dataset.susScrollListened = '1';
        link.addEventListener('click', saveState);
      }
    });
  }

  async function loadPage(pageNumber) {
    const nextUrlInput = document.querySelector('[data-next-url]');
    if (!nextUrlInput) return false;

    const url = nextUrlInput.value.replace(/page=[0-9]+/, 'page=' + pageNumber);
    try {
      const response = await fetch(url);
      if (!response.ok) return false;
      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const newGrid = doc.querySelector('.load-more-grid');
      const currentGrid = document.querySelector('.load-more-grid');
      if (!newGrid || !currentGrid) return false;

      currentGrid.insertAdjacentHTML('beforeend', newGrid.innerHTML);

      // Update hidden inputs so load-more.js continues from the correct page
      document.querySelectorAll('[data-current-page]').forEach(function (el) {
        el.value = pageNumber;
      });
      document.querySelectorAll('[data-next-url]').forEach(function (el) {
        el.value = url;
      });

      return true;
    } catch (e) {
      return false;
    }
  }

  async function restoreState(fromBfCache) {
    const stored = sessionStorage.getItem(STORAGE_KEY);
    if (!stored) return;

    let state;
    try { state = JSON.parse(stored); } catch (e) { return; }

    if (state.key !== getCollectionKey()) return;

    sessionStorage.removeItem(STORAGE_KEY);

    if (fromBfCache) {
      // Content already restored by bfcache — re-apply scroll after iOS resets it
      requestAnimationFrame(() => {
        window.scrollTo({ top: state.scrollY, behavior: 'instant' });
      });
      attachCardListeners();
      return;
    }

    // Scroll immediately so the user has orientation while pages load
    window.scrollTo({ top: state.scrollY, behavior: 'instant' });

    // Load any missing pages in the background
    if (state.page > 1) {
      const pageInput = document.querySelector('[data-current-page]');
      let loadedPage = pageInput ? parseInt(pageInput.value, 10) : 1;

      while (loadedPage < state.page) {
        const success = await loadPage(loadedPage + 1);
        if (!success) break;
        loadedPage++;
      }

      // Re-attach listeners to cards added during restore
      attachCardListeners();

      // Final scroll correction now that the full grid is in place
      window.scrollTo({ top: state.scrollY, behavior: 'instant' });
    }
  }

  // Re-attach listeners whenever the product grid changes (filter re-renders or load-more)
  const grid = document.querySelector('#ProductGridContainer');
  if (grid) {
    new MutationObserver(attachCardListeners).observe(grid, { childList: true, subtree: true });
  }

  attachCardListeners();

  window.addEventListener('pageshow', function (event) {
    restoreState(event.persisted);
  });

  window.addEventListener('pageshow', function (event) {
    const stored = sessionStorage.getItem(STORAGE_KEY);
    const itemCount = document.querySelectorAll('#ProductGridContainer li').length;
    const pageInput = document.querySelector('[data-current-page]');
    const nextUrl = document.querySelector('[data-next-url]');

    restoreState(event.persisted);
  });

})();
